
<mat-drawer-container [hasBackdrop]="true">
    <mat-drawer #sidenav [mode]="'over'">
        <app-insights-filter-sidebar
            [filterForm]="filterForm"
            (closeButtonClicked)="sidenav.close()"
            [statusList]="statusList"
            [userList]="userList$ | async"
            [timeFrameList]="timeFrameList"
            [formType]="formsList$ | async"
            [aircraftList]="aircraftList$ | async"
            [formList]="formList$ | async"
            [groupFilterOptions]="groupFilterOptions$ | async"></app-insights-filter-sidebar>
    </mat-drawer>
    <mat-drawer-content class="app-content listings">
        <app-insights-filter-topbar
            [filterForm]="filterForm"
            [currentFilters]="currentFilters"
            (filterButtonClicked)="sidenav.open()"
            [statusList]="statusList"
            [userList]="userList$ | async"
            [timeFrameList]="timeFrameList"
            [formType]="formsList$ | async"
            [aircraftList]="aircraftList$ | async"
            [formList]="formList$ | async"
            [groupFilterOptions]="groupFilterOptions$ | async"></app-insights-filter-topbar>

        <app-loading-indicator
            *ngIf="!(stats$ | async); else content"></app-loading-indicator>

        <ng-template #content>
            <div *ngIf="!(stats$ | async)?.meta?.results; else stats">
                <div class="empty-state">
                    <img
                        class="no-assessment"
                        id="img-empty-insights"
                        src="/assets/img/empty-insights.svg"
                        alt="No Stats to Display" />
                    <h2>No Statistics to Display</h2>
                    <p>
                        Change the filters to view different
                        <br />
                        trends and insights.
                    </p>
                    <a
                        class="open-filters"
                        (click)="sidenav.open(); $event.stopPropagation()">
                        Change Filtered View
                    </a>
                </div>
            </div>

            <ng-template #stats>
                <!-- just one form -->
                <app-form-type-stats
                    *ngIf="statsData$ | async as stats"
                    [stats]="stats"
                    [formType]="filterForm.controls.formType.value">
                </app-form-type-stats>

                <!-- for múltiples forms -->
                <ng-container *ngIf="multipleStatsData$ | async as multiStats">
                    <ng-container *ngFor="let entry of multiStats">
                        <h3 class="text-xl font-semibold">
                            {{ getAssessmentTitle(entry.assessmentId) }}
                            <span class="view-more"
                            (click)="filterByAssessmentId(entry.assessmentId)"
                            >View More ></span>
                        </h3>

                        <form-type-row-stats
                            *ngIf="entry?.summary"
                            [assessmentId]="entry.assessmentId"
                            [stats]="entry.summary">
                        </form-type-row-stats>
                    </ng-container>
                </ng-container>



            </ng-template>



            <div
                class="footer-links"
                *ngIf="(stats$ | async)?.meta?.results > 0 || (multipleStatsData$ | async)?.length > 0">
                <p>Looking for different statistics? Let us know!</p>
                <a
                    class="request"
                    target="_blank"
                    href="https://www.risesms.com/feature-request">
                    Request Specific Statistics
                </a>
            </div>
        </ng-template>

        <div class="right-corner-control blue" *appMobile>
            <a (click)="exportPDF()">
                <span>Export Insights</span>
            </a>
        </div>
    </mat-drawer-content>
</mat-drawer-container>

